var initialState = require('./initialState');
var analytics = require('../utils/analytics');
var Redux = require("redux");
var thunk = require('redux-thunk').default;
var createLogger = require('redux-logger');
var routerMiddleware = require('react-router-redux').routerMiddleware;
var rootReducer = require('./reducers');

var nodeEnv = process.env.NODE_ENV || 'development';

function configureStore(preloadedState, routerState) {
  var state = preloadedState || initialState;

  if(nodeEnv === 'development') {
    var logger = createLogger();
    return Redux.createStore(
      rootReducer,
      state,
      Redux.applyMiddleware(
        thunk,
        routerMiddleware(routerState),
        logger,
        analytics
      )
    )
  } else {
    return Redux.createStore(
      rootReducer,
      state,
      Redux.applyMiddleware(
        thunk,
        routerMiddleware(routerState),
        analytics
      )
    )
  }
}

module.exports.configureStore = configureStore;



// WEBPACK FOOTER //
// ./src/common/modules/store.js